export const CHECKOUT_OUTCOME_POLL_MS = 1_500
export const CHECKOUT_OUTCOME_TIMEOUT_MS = 30_000

/**
 * `processing` is confirmed and still clearing: it is polled like an unpaid
 * read, to the same bound, and ends `unconfirmed` — recorded when it clears,
 * never offered to be paid again.
 */
export type CheckoutOutcomeRead =
  | 'paid'
  | 'unpaid'
  | 'processing'
  | 'expired'
  | 'read_error'

export type CheckoutOutcomeState =
  | 'poll'
  | 'succeeded'
  | 'unconfirmed'
  | 'expired'

export const CHECKOUT_OUTCOME_NOTICE = {
  expired:
    'This payment session has expired. Change the payment details and try again.',
  unconfirmed:
    'The card was submitted. It will show in giving once it is recorded.',
} satisfies Record<
  Extract<CheckoutOutcomeState, 'expired' | 'unconfirmed'>,
  string
>

/** A checkout stays open to delayed server recording, but never polls forever. */
export function checkoutOutcomeStep(input: {
  attempt: number
  elapsedMs: number
  latestOutcome: CheckoutOutcomeRead
}): CheckoutOutcomeState {
  if (input.latestOutcome === 'paid') return 'succeeded'
  if (input.latestOutcome === 'expired') return 'expired'
  return input.elapsedMs >= CHECKOUT_OUTCOME_TIMEOUT_MS ? 'unconfirmed' : 'poll'
}

/** An expired checkout releases every lock that belongs to that attempt. */
export function resetExpiredCheckout(...resetters: (() => void)[]) {
  for (const reset of resetters) reset()
}
